import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
} from "@mui/material";

import CurrencyCell from "../../../component/CurrencyCell";

const columns = [
  { field: "workorder", label: "Allocation" },
 
  { field: "DrAmount", label: "Data From Demand 6" },
   { field: "CrAmount", label: "Data From Other Railway (C/1)" },
  { field: "Total", label: "Total" },
];


const parseAmount = (value) => {
  if (value == null) return 0;

  let str = String(value).replace(/,/g, "").trim();

  // Handle trailing minus
  if (str.endsWith("-")) {
    str = "-" + str.slice(0, -1);
  }

  return Number(str) || 0;
};


export default function WGRTable({
  rows,
  shop,
  totals,
  showTotal = true,
}) {
  return (
    <TableContainer>
      <Table
        size="small"
       stickyHeader
      >
        <TableHead>
          <TableRow>
            {columns.map((column) => (
              <TableCell
                key={column.field}
                align="right"
                sx={{
                  fontWeight: 700,
                  bgcolor: "grey.200",
                }}
              >
                {column.label}
              </TableCell>
            ))}
          </TableRow>
        </TableHead>

        <TableBody>
          {rows.map((row, index) => {
  const total = (parseAmount(row.DrAmount) || 0) - (parseAmount(row.CrAmount) || 0);

  return (
    <TableRow
      key={index}
      hover
      sx={{
        "&:nth-of-type(even)": {
          bgcolor: "grey.50",
        },
      }}
    >
      
      <TableCell colSpan={1} sx={{ paddingLeft: "280px" }} align="left">{row.workorder}</TableCell>

      <TableCell align="right">
        <CurrencyCell value={row.DrAmount} />
      </TableCell>

      <TableCell align="right">
        <CurrencyCell value={row.CrAmount} />
      </TableCell>

      <TableCell align="right">
        <CurrencyCell value={total} />
      </TableCell>
    </TableRow>
  );
})}

          {showTotal && (
            <TableRow
              sx={{
                bgcolor: "primary.light",
                "& td": {
                  fontWeight: 700,
                  borderTop: "2px solid",
                  borderColor: "primary.main",
                },
              }}
            >
              <TableCell colSpan={1} align="right">
               Total Amount
              </TableCell>

             

              <TableCell align="right">
                <CurrencyCell value={totals.DrAmount} />
              </TableCell>

               <TableCell align="right">
                <CurrencyCell value={totals.CrAmount} />
              </TableCell>

                <TableCell align="right">
                <CurrencyCell value={totals.Total} />
              </TableCell>

            </TableRow>
          )}
        </TableBody>
      </Table>
    </TableContainer>
  );
}